<template>
  <div style="position: relative"  v-show="isShow">
    <div class="img-wrapper" @click="close">
      <div class="img-content">
        <img class="img" :src="src" alt="">
      </div>
    </div>
    <div class="back" ></div>
  </div>
</template>

<script>

  export default {
    name: "ImgShow",
    data() {
      return {
        isShow: false,
        src:'',

      }
    },
    methods: {
      close() {
        this.isShow = false
      }
    }
  }
</script>

<style scoped>
  img {
    max-width: 90%;
    display: inline-block;
  }

  .img-content {
    max-width: 50%;
    display: inline-block;
    background-color: white;
    padding: 20px;

  }

  .img-wrapper {
    position: fixed;
    z-index: 1000001;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    overflow: auto;
    padding: 5% 0;
    box-sizing: border-box;
    text-align: center;
  }

  .back {
    position: fixed;
    width: 100%;
    min-height: 100vh;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 100000;
  }

</style>
